import { COMPANY_TYPES, COMPANY_TYPE_TOTAL } from "../../lib/placementTrends";

/**
 * FIG-PLC-005 — the 188 companies that recruited between 2022 and 2026, by what
 * kind of business they are.
 *
 * Seven nominal categories, but identity is carried by the row label, so seven
 * hues would buy nothing and cost legibility. One hue, ranked, direct-labelled.
 *
 * An ordered list rather than a drawing: the ranking is then real document
 * structure, and the labels wrap instead of being clipped by a fixed column.
 *
 * This figure is CUMULATIVE across five years. It is deliberately kept out of
 * the per-batch headline, which counts the 52 distinct employers in the 2026
 * drive sheet.
 */
const PEAK = Math.max(...COMPANY_TYPES.map((c) => c.companies));

export function PlacementCompanyMix() {
  return (
    <figure className="pfig">
      <div className="pfig-head">
        <span className="pfig-meta">
          FIG-PLC-005 &middot; {COMPANY_TYPE_TOTAL} companies by category, 2022&ndash;2026
          cumulative &middot; source: BIET Training &amp; Placement Cell
        </span>
      </div>

      <ol className="pfig-rank">
        {COMPANY_TYPES.map((c) => (
          <li key={c.label}>
            <span className="pfig-rank-label">{c.label}</span>
            <span className="pfig-rank-track">
              <span
                className="pfig-rank-bar"
                style={{ width: `${(c.companies / PEAK) * 100}%` }}
                data-tip={`${c.label} · ${c.companies} of ${COMPANY_TYPE_TOTAL} companies`}
                tabIndex={0}
              />
            </span>
            <span className="pfig-rank-val">{c.companies}</span>
          </li>
        ))}
      </ol>
    </figure>
  );
}
